/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Payment_Short_PartialInputs */

const vi_order_payment_short_partial = /** @type {(inputs: Order_Payment_Short_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một phần`)
};

/**

* @param {Order_Payment_Short_PartialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_short_partial = /** @type {((inputs?: Order_Payment_Short_PartialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_Short_PartialInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_short_partial(inputs)
});